import { render } from "./SelectedBulkOverview.vue?vue&type=template&id=37009bc8"
import script from "./SelectedBulkOverview.vue?vue&type=script&lang=js"
export * from "./SelectedBulkOverview.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__